module.exports = __webpack_public_path__ + "static/nic-154dcae5555aa7b73ce44f94d4a7be14.png";